import React from "react";
import { BsPencil, BsGeoAlt } from "react-icons/bs";
import { Link } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  Dumpster,
  dumpsterSizeToText,
  dumpsterLocationBadgeText,
} from "../../../../models";
import {
  setSelectedDumpster,
  toggleShowEditDumpsterModal,
  setShowSetLocationModal,
} from "../../dumpstersSlice";

import "./DumpsterDetailsCard.scss";

export interface DumpsterDetailsCardProps {
  dumpster: Dumpster;
}

export function DumpsterDetailsCard(props: DumpsterDetailsCardProps) {
  const dispatch = useAppDispatch();
  const { dumpster } = props;

  const vehicles = useAppSelector((state) => state.vehicles.vehicles) || [];
  const truckLabel = dumpster.currentVehicleId
    ? vehicles.find((v) => v.id === dumpster.currentVehicleId)?.label
    : undefined;
  const locationText = dumpsterLocationBadgeText(
    dumpster.locationType,
    truckLabel
  );

  const onEditClick = () => {
    dispatch(setSelectedDumpster(dumpster));
    dispatch(toggleShowEditDumpsterModal());
  };

  const onSetLocationClick = () => {
    dispatch(setShowSetLocationModal(dumpster));
  };

  const formatAddress = () => {
    const parts = [dumpster.currentAddress, dumpster.currentCity, dumpster.currentZip].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "Not set";
  };

  return (
    <div className="dumpster-details-card-component">
      <div className="header">
        <div className="header-content">
          <div className="header-title">{dumpster.label}</div>
          <span className={`location-badge location-${dumpster.locationType}`}>
            {locationText}
          </span>
        </div>

        <div className="buttons-container">
          <div className="button-container" onClick={onSetLocationClick}>
            <BsGeoAlt className="icon" />
            <div>Set Location</div>
          </div>

          <div className="button-container" onClick={onEditClick}>
            <BsPencil className="icon" />
            <div>Edit</div>
          </div>
        </div>
      </div>

      <div className="details-container">
        <div className="column">
          <div className="item-container">
            <div className="label">Size:</div>
            <div className="value">{dumpsterSizeToText[dumpster.dumpsterSize]}</div>
          </div>

          <div className="item-container">
            <div className="label">Location Type:</div>
            <div className="value">{locationText}</div>
          </div>

          <div className="item-container">
            <div className="label">Current Address:</div>
            <div className="value">{formatAddress()}</div>
          </div>
        </div>

        <div className="column">
          {dumpster.currentOrderId && (
            <div className="item-container">
              <div className="label">Current Order:</div>
              <div className="value">
                <Link to={`/orders/${dumpster.currentOrderId}`} className="order-link">
                  View Order
                </Link>
              </div>
            </div>
          )}

          <div className="item-container">
            <div className="label">Notes:</div>
            <div className="value">{dumpster.notes || "No notes"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
